import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { UserRole } from '../../data/UpuServiceDataCertificationRequestModel';
import { NavigationLink } from '../../models';
import { ROUTE_DATA } from '../../router/route-data';
import { ScrollObserver } from '../../shared/scroll-observer-directive';
import { TranslationDirective } from '../../shared/translation-directive';
import { NotificationButton } from '../notification-panel/notification-button/notification-button';
import { UserApi } from '../user/user-api';
import { UserMenuComponent } from './user-menu/user-menu';

@Component({
  selector: 'upu-top-bar',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    RouterLinkActive,
    RouterLink,
    UserMenuComponent,
    TranslationDirective,
    MatDivider,
    ScrollObserver,
    NotificationButton,
  ],
  templateUrl: './top-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBarComponent {
  private readonly userApi = inject(UserApi);

  private readonly systemLogsAllowedRoles: ReadonlySet<UserRole> = new Set([
    UserRole.Administrator,
    UserRole.Superuser,
  ]);

  protected readonly navigationLinks = computed<NavigationLink[]>(() => [
    {
      id: 'top-bar-facilities-link',
      icon: 'local_post_office',
      label: ROUTE_DATA.facilities.title,
      route: ROUTE_DATA.facilities.path,
    },
    {
      id: 'top-bar-requests-link',
      icon: 'article',
      label: 'common.requests',
      route: ROUTE_DATA.requests.path,
    },
    {
      id: 'top-bar-system-logs-link',
      icon: 'assignment',
      label: ROUTE_DATA['system-logs'].title,
      route: ROUTE_DATA['system-logs'].path,
      hidden: !this.systemLogsAllowedRoles.has(this.userApi.userRole()),
    },
  ]);

  protected readonly hasScrolled = signal(false);
}
